/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import dragon from "assets/img/Dragon.png"
import Unicorn from "assets/img/Unicorn.png"
import phoenix from "assets/img/Phoenix.png"
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function Index() {
  return (
    <>
      <IndexNavbar fixed />
      <section  className="header relative bg-black pt-16 items-center flex h-screen max-h-860-px">
        <div className="container mx-auto items-center flex flex-wrap">
          <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
            <div className="pt-32 sm:pt-0">
              <h2 className=" my-Font font-semibold text-5xl text-white">
              War for Power! 
              </h2>
              <p className="mt-4 text-md leading-relaxed font-bold mx-auto  text-white">
              The Meta-Floki Avatars Ecosystem heralds the new era of high-yield autostaking tokens on the<br/> Binance Smart Chain with a 50% first-year APY 
              {" "}
              <br />
                

              </p>
              <div className="mt-12">
                <a
                  href="https://pancakeswap.finance/swap?outputCurrency=0x6364c250a26f171e05b9D26b66baB17921eC72b9"
                  target="_blank"
                  className="get-started text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-lightBlue-800 active:bg-lightBlue-800 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  Buy metafloki Avatars
                </a>
                <a
                  href="/admin/settings"
                  className="github-star ml-1 text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                  target="_blank"
                >
                 DApp
                </a>
              </div>
            </div>
          </div>
        </div>

        <img
        style={{"marginTop":"100px"}}
          className="absolute top-0 b-auto right-0 mb-10 pt-20  sm:w-6/12 mt-32  w-10/12 max-h-860px"
          src={require("assets/img/logo .png").default}
          alt="..."
        />
      </section>

      <section id="AboutUs" style={{"backgroundImage":`url("https://metaflokiavatars.com/wp-content/uploads/2021/12/a3.jpg")`,
       "backgroundSize": "cover", 
       "backgroundPosition": "top center",
        "backgroundRepeat": "no-repeat",
        }} className="mt-48 text-white  md:mt-40 pb-40 relative bg-blueGray-100">
        <div
          className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-100 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container my-Font mx-auto">
          <div className="flex flex-wrap items-center">
            <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto -mt-32">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-lightBlue-800">
                <img
                  alt="..."
                  src={phoenix}
                  className="w-full align-middle rounded-t-lg"
                />
                <blockquote className="relative p-8 mb-4">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    className="absolute left-0 w-full block h-95-px -top-94-px"
                  >
                    <polygon
                      points="-30,95 583,95 583,65"
                      className="text-lightBlue-500 fill-current"
                    ></polygon>
                  </svg>
                  <h4 className="my-Font text-xl font-bold text-white">
                  About metafloki Avatars
                  </h4>
                  <p className="text-md font-light mt-2 text-white">
                  Meta Floki is Play to earn NFT game, offering an exclusive opportunity to grow your token while playing.
                  </p>
                </blockquote>
              </div>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="flex flex-wrap">
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-sitemap"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                      Buy & Sell Tax
                      </h6>
                      <p className="mb-4 my-Font text-white">
                      Here at Meta-Floki Avatars security for investors is at the forefront to ensure every member of our community is protected. We have carried out extensive ways of
                   safeguarding our community within the world of crypto. Firstly, the liquidity has been 
                   completely locked and the contract has been audited by an external party. 
                   We also feature many dynamic components for React,
                        Meta-Floki Avatars Tax is 1% for buying & 1% for selling on each transaction.
                      </p>
                    </div>
                  </div>
                  
                </div>
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col min-w-0 mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-newspaper"></i>
                      </div>
                      <h6 className="text-xl my-Font mb-1 font-semibold">The Vision </h6>
                      <p className="mb-4 text-white">
                      Our Vision is to create a whole  new world of imagination filled in our game, we Will be bringing bigger versions of games with more creative planetary
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-file-alt"></i>
                      </div>
                      <h6 className="text-xl my-Font mb-1 font-semibold">
                      The Power
                      </h6>
                      <p className="mb-4 text-white">
                      Meta-Floki Avatars brings entirely new changes to the wildly successful Titano and Safuu protocols.
                       MetaFloki matches and then exceeds the highest APY seen in BSC thus far, 
                      with a record-breaking 50% APY over one year. 
                      The Meta-Floki Avatars Protocol delivers automatic-staking to all holders every 15 minutes. 
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="Buy" className="container mx-auto overflow-hidden pb-20">
          <div className="flex flex-wrap items-center">
            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-sitemap text-xl"></i>
              </div>
              <h3 className="text-4xl mb-2 my-Font font-semibold leading-normal">
              How to Buy
              </h3>
              <h3 className="text-xl mb-2 font-semibold leading-normal">
              Purchase metafloki Avatars Today!
              </h3>
              <p className="text-lg font-bold leading-relaxed mt-4 mb-4 text-white">
              You can purchase Meta-Floki Avatars from Pancakeswap using your Mobile Wallet or Metamask.
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-white">
              Create a MetaMask or TrustWallet using either a desktop computer or an iOS/Android mobile device. 
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-white">
              You can purchase BNB directly through our swap using Debit/credit card aswell as Google or Apple pay!
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-white">
              Access your wallet on Pancakeswap or Flooz.Trade by clicking ‘Connect to a wallet’ and selecting Meta-Floki Avatars by adding the Contract Address. 
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-white">
              Set slippage to 12% and swap BNB for Meta-Floki Avatars.
              </p>
              <div className="block pb-6">
               
               
               
              </div>
             
            </div>

            <div className="w-full md:w-5/12 px-4 mr-auto ml-auto mt-32">
              <div className="relative flex flex-col min-w-0 w-full mb-6 mt-48 md:mt-0">
              <iframe width="100%" height="670" src="https://pancakeswap.finance/swap?outputCurrency=0x6364c250a26f171e05b9D26b66baB17921eC72b9" title="Flooz Trade" frameborder="0" allow="clipboard-read; clipboard-write; web-share; accelerometer *; autoplay *; camera *; gyroscope *; payment *"> </iframe>
              </div>
            </div>
          </div>

          <div id="Tokenomics" className="flex flex-wrap  pt-32">
            <div className="w-full md:w-6/12 px-4 mr-auto ml-auto mt-32">
              <div className="justify-center flex flex-wrap relative">
                <div className="my-4 w-full lg:w-6/12 px-4">
                  <a
                    href="https://pancakeswap.finance/swap?outputCurrency=0x6364c250a26f171e05b9D26b66baB17921eC72b9"
                    target="_blank"
                  >
                    <div className="bg-red-50 opacity-10 shadow-lg rounded-lg text-center p-8">
                     
                      <p className="text-lg text-white mt-4 font-semibold">
                        
                          Name<br/>
                          MetaFlokiAvatars

                      </p>
                    </div>
                  </a>
                 
                    <div className="bg-lightBlue-50 shadow-lg rounded-lg text-center p-8 mt-8">
                    
                      <p className="text-lg text-white mt-4 font-semibold">
                       
                            Decimal<br/>
                            9

                      </p>
                    </div>
                
                 
                    <div className="bg-blueGray-70 shadow-lg rounded-lg text-center p-8 mt-8">
                     
                      <p className="text-lg text-white mt-4 font-semibold">
                       
                        Buy Taxes<br/>
                        1%

                      </p>
                    </div>
                 
                </div>
                <div className="my-4 w-full lg:w-6/12 px-4 lg:mt-16">
                 
                    <div className="bg-yellow-50 shadow-lg rounded-lg text-center p-8">
                      <p className="text-lg text-white mt-4 font-semibold">
                      
                        Sell Taxes<br/>
                        1%

                      </p>
                    </div>
                 
                  <a
                    href="https://pancakeswap.finance/swap?outputCurrency=0x6364c250a26f171e05b9D26b66baB17921eC72b9"
                    target="_blank"
                  >
                    <div className="bg-red-50 shadow-lg rounded-lg text-center p-8 mt-8">
                      
                      <p className="text-lg text-white mt-4 font-semibold">
                     
                                  Symbol: Avatar

                      </p>
                    </div>
                  </a>
                  <a
                    href="https://bscscan.com/address/0x6364c250a26f171e05b9D26b66baB17921eC72b9"
                    target="_blank"
                  >
                    <div className="bg-emerald-50 shadow-lg rounded-lg text-center p-8 mt-8">
                     
                      <p className="text-lg text-white mt-4 font-semibold">
                        
                          Total Supply:<br/>
                          100,000,000

                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-drafting-compass text-xl"></i>
              </div>
              <h3 className="text-xl mb-2 font-semibold leading-normal">
              Meta-Floki Avatars Tokenomics
              </h3>
              <h3 className="text-3xl mb-2 font-semibold leading-normal">
          
              </h3>
              <p className="text-lg font-semibold  leading-relaxed mt-4 mb-4 text-white ">
              Contract:
              </p>
              <p className="text-xs font-light -pl-10 leading-relaxed mt-4 mb-4 text-white ">
              0x6364c250a26f171e05b9D26b66baB17921eC72b9
              </p>
              <a
                href="https://bscscan.com/token/0x6364c250a26f171e05b9D26b66baB17921eC72b9"
                target="_blank"
                className="font-bold text-white  hover:text-blueGray-500 ease-linear transition-all duration-150"
              >
                View all{" "}
                <i className="fa fa-angle-double-right ml-1 leading-relaxed"></i>
              </a>
            </div>
          </div>
        </div>

        <div  className="container mx-auto px-4 pb-32 pt-48">
          <div className="items-center flex flex-wrap">
            <div className="w-full md:w-5/12 ml-auto px-12 md:px-4">
              <div className="md:pr-12">
                
                <h3 className="text-4xl my-Font font-semibold">
                Why you should hold $MetaFloki Avatars
                </h3>
                <h3 className="text-2xl font-semibold">
                50% APY
                </h3>
                <p className="mt-4 text-lg leading-relaxed text-white">
                  <h3 className="text-2xl text-bold text-white">Initial Investment</h3>
                $150
                </p>
                <p className="mt-4 text-lg leading-relaxed text-white">
                  <h3 className="text-2xl text-bold text-white">3 MONTH</h3>
                $169
                </p>
                <p className="mt-4 text-xl leading-relaxed text-white">
                <h3 className="text-2xl text-bold text-white">6 MONTHS</h3>
                $191
                </p>
                <p className="mt-4 text-xl leading-relaxed text-white">
                <h3 className="text-2xl text-bold text-white">9 MONTHS</h3>
                $215
                </p>
                <p className="mt-4 text-xl leading-relaxed text-white">
                <h3 className="text-2xl text-bold text-white ">12 MONTHS</h3>
                $225
                </p>
                <p className="text-xl"> The auto-staking, auto-compounding protocol is MetaFloki. All you have to do is hold!
                </p>
              </div>
            </div>

            <div id="Team" className="w-full md:w-6/12 mr-auto px-4 pt-24 md:pt-0">
              <img
                alt="..."
                className="max-w-full rounded-lg shadow-xl"
                style={{
                  transform:
                    "scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg)",
                }}
                src={"https://metaflokiavatars.com/wp-content/uploads/2022/01/FIRE-FLOKI-God.png"}
              />
            </div>
          </div>
        </div>

        <div className="justify-center text-center flex flex-wrap mt-24">
          <div className="w-full md:w-6/12 px-12 md:px-4">
            <h2 className="font-semibold text-white text-4xl">Experienced, Talented and Creative!</h2>
            <p className="text-lg leading-relaxed mt-4  mb-4 text-white">
            The Team here at Meta-Floki Avatars are a very experienced and diverse team.
By blending the expertise of our investment team, marketing team, moderators and developers, we have built an exclusive cryptocurrency for our community. 
Meta-Floki Avatars positions itself as a solid extension in the crypto space. For that reason, we care and value our community. 
            </p>
          </div>
        </div>
      </section>

      <section  
          className="block relative z-1 bg-blueGray-600 ">
        <div className="container bg-blueGray-600 mx-auto">
          <div className="justify-center flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4  -mt-24">
              <div className="flex flex-wrap">
                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-2xl text-white my-Font font-semibold pb-4 text-center">
                  +10
                  </h5>
                  <h5 className="text-xl text-white my-Font font-semibold pb-4 text-center">
                  Team & Dedicated People
                  </h5>
                  
                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-2xl text-white my-Font font-semibold pb-4 text-center">
                  5
                  </h5>
                  <h5 className="text-xl text-white my-Font font-semibold pb-4 text-center">
                  Core & Marketing Team
                  </h5>
                 
                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-2xl text-white my-Font font-semibold pb-4 text-center">
                  +50
                  </h5>
                  <h5 className="text-xl text-white my-Font font-semibold pb-4 text-center">
                  Combined Years of Experience
                  </h5>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="roadmap" className="py-5 bg-blueGray-800 overflow-hidden">
         <img src="https://ik.imagekit.io/lzgpc48la/Roadmap_FLTKP-r15.png?ik-sdk-version=javascript-1.4.3&updatedAt=1667757351983" alt="roadmap" style={{"width": "100%", "height": "100%"}} />
         
       </section>

     
      <Footer />
    </>
  );
}
